import { render, staticRenderFns } from "./LeiteColetado.vue?vue&type=template&id=e20461e2&scoped=true&"
import script from "./LeiteColetado.vue?vue&type=script&lang=js&"
export * from "./LeiteColetado.vue?vue&type=script&lang=js&"
import style0 from "./LeiteColetado.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./LeiteColetado.vue?vue&type=style&index=1&id=e20461e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20461e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
